<section class="user-info-container">

    <div class="user-menu-header">
            <div>
                <span class="user-title">User Information</span>
                <p class="user-info-desc">View your account details.</p>
            </div>

            @if (userEmail) {
                <div class="user-item-cont">
                    <span class="user-subtitle">Email Address</span>
                    <p class="user-info-desc locator-email">{{ userEmail }}</p>
                </div>
            }

            <div class="user-item-cont">
                <span class="user-subtitle">Subscription Tier</span>
                <p class="user-info-desc locator-subscription">{{ subscriptionTier }}</p>
            </div>

            <div class="user-item-cont">
                <span class="user-subtitle">Subscription End Date</span>
                <p class="user-info-desc locator-end-date">{{ endDate }}</p>
            </div>

            <div class="user-menu-actions">
                <button mat-menu-item (click)="initLogout()">
                    <span class="btn-label">Log Out</span>
                </button>
            </div>

        </div>

</section>